import React, {Component} from 'react';
import Spinner from 'react-spinkit';
import {injectIntl} from 'react-intl';

import 'style/components/ui/loading/spog-spinner.scss';

/** Component to render a spinner */
class SpogSpinner extends Component {

    render() {
        const {intl: {formatMessage}} = this.props;

        return (
            <Spinner
                name="line-scale-pulse-out"
                title={formatMessage({id: 'label.state.pending'})}
                className="spog-spinner"
                fadeIn="none"
            />
        );
    }
}


export default injectIntl(SpogSpinner);



// WEBPACK FOOTER //
// ./src/components/ui/loading/SpogSpinner.jsx